import React from 'react';
import { Dropdown, Button, message } from 'antd';
import { MoreOutlined, EditOutlined, DeleteOutlined } from '@ant-design/icons';

const PaymentMethodMenu = ({ 
  paymentMethod, 
  onEdit, 
  onDelete, 
  onToggleStatus,
  isUpdating = false,
  isDeleting = false
}) => {
  const handleMenuClick = ({ key }) => {
    switch (key) {
      case 'edit':
        onEdit(paymentMethod);
        break;
      case 'delete':
        onDelete(paymentMethod);
        break;
      case 'toggle':
        onToggleStatus(paymentMethod);
        break;
      default:
        break;
    }
  };

  const menuItems = [
    {
      key: 'edit',
      label: 'Edit Payment Method',
      icon: <EditOutlined className="text-blue-600" />,
    },
    {
      key: 'toggle',
      label: paymentMethod?.status === 1 ? 'Deactivate' : 'Activate',
      icon: (
        <div className={`w-3 h-3 rounded-full ${paymentMethod?.status === 1 ? 'bg-red-500' : 'bg-green-500'}`} />
      ),
    },
    {
      type: 'divider',
    },
    {
      key: 'delete',
      label: 'Delete Payment Method',
      icon: <DeleteOutlined className="text-red-600" />,
      danger: true,
    },
  ];

  return (
    <Dropdown
      menu={{ 
        items: menuItems, 
        onClick: handleMenuClick 
      }}
      trigger={['click']}
      placement="bottomRight"
      disabled={isUpdating || isDeleting}
    >
      <Button
        type="text"
        icon={<MoreOutlined />}
        className="text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-lg p-0 flex items-center justify-center"
        size="small"
        loading={isUpdating || isDeleting}
      />
    </Dropdown>
  );
};

export default PaymentMethodMenu;
